import styled from 'styled-components';

import { AlertIcon } from '@libs/components';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.9rem 1rem 0 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  box-shadow: ${({ theme }) => theme.shadows.md};
  ${({ theme }) => theme.media.tablet`
        padding: 0.9rem 3.9rem 0 3.9rem;
    `}
`;

export const HorizontalSeparator = styled.div`
  height: 0.05rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;

export const RatesWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.8rem 0;
`;
export const RateContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;
export const RateSeparator = styled.div`
  width: 0.05rem;
  height: 2.7rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;

export const VerticalSeparator = styled.div`
  width: 0.05rem;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;

export const CustomAlertIcon = styled(AlertIcon)`
  height: 2.1rem;

  margin-top: -2rem;
`;

export const TitleWrapper = styled.div`
  margin-top: 0.8rem;
  margin-bottom: 1.2rem;
  text-align: center;
`;
